<template>
    <card-wrapper :title="Lang.get('employerdashboard::pages/employee/details.title', {fullname: employee.full_name})"
                 :subtitle="Lang.get('employerdashboard::pages/employee/details.subtitle')">
        <template v-slot:nav aria-label="breadcrumb">
            <ol class="breadcrumb font-poppins font-weight-light font-size-14 color-blue px-0 bg-transparent">
                <li class="breadcrumb-item">
                    <a
                        :href="route('nl.employerdashboard.employees.overview', $page.props.auth.user.selected_company.uuid)"
                        class="font-poppins font-weight-semibold color-blue">
                        {{ Lang.get('employerdashboard::pages/employee/breadcrumb.overview') }}</a>
                </li>
                <li class="breadcrumb-item">
                    <a
                        :href="route('nl.employerdashboard.employee.profile', {company_as_uuid: $page.props.auth.user.selected_company.uuid, employee_uuid: employee.uuid})"
                        class="font-poppins font-weight-semibold color-blue">
                        {{ Lang.get('employerdashboard::pages/employee/breadcrumb.profile') }}</a>
                </li>
                <li class="breadcrumb-item color-blue" aria-current="page">
                    {{ Lang.get('employerdashboard::pages/employee/breadcrumb.details') }}</li>
            </ol>
        </template>

        <div class="row mt-5">
            <div class="alert alert-warning">
                <i class="fa fa-exclamation-circle pr-2"></i>
                    Deze medewerker is afgemeld
                <p class="pt-2 pl-4">
                    <strong>{{ Lang.get('employerdashboard::pages/employee/profile.explanation') }}:</strong><br />
                    <span>{{ employee.disabled_from_participation_reason }}</span>
                </p>
                <p class="pt-1 pl-4" v-html="Lang.get('employerdashboard::pages/employee/profile.disabled_from_participation.footer', {reference: employee.disabled_from_participation_reference})"></p>
            </div>
        </div>

    </card-wrapper>
</template>

<script>
import CardWrapper from '@/Shared/CardWrapper';
import CardLayout from "@/Shared/CardLayout";
import TextInput from "@/Shared/TextInput";
import SelectInput from "@/Shared/SelectInput";

export default {
    metaInfo() {
        return {
            title: Lang.get('employerdashboard::pages/employee/details.title'),
        }
    },
    components: {
        CardWrapper,
        CardLayout,
        SelectInput,
        TextInput,
    },
    props: {
        errors: Object,
        employee: Object,
        payroll_tax_credit_options: Object,
        countries: Object,
        preferred_country: String,
    },
}
</script>
